import React from "react";
import { connect } from "react-redux";
import { SubTaskDetailContainerStyled } from "./styled";
import { withRouter } from "navigations/withRouter";
import { MdAdd } from "react-icons/md";
import { portalService } from "apiServices";
import { toast } from "react-toastify";
import moment from "moment";
import momentTZ from "moment-timezone";
import { Buttons, Displays, Forms, Modals, Tables } from "components";

class SubTaskDetailContainer extends React.Component {
  state = {
    isLoading: true,
  };

  componentDidMount() {
    this.fetchData();
  }

  fetchData = async () => {
    let resArr = await Promise.all([
      portalService.GET_MAIN_TASK_DETAIL(this.props.router.params.id),
      portalService.GET_SUB_TASK_BY_MAIN_TASK_ID(this.props.router.params.id),
    ]);
    if (resArr) {
      this.setState({
        // initialValues: res.data,
        mainTaskDetail: resArr[0].data,
        subTaskData: resArr[1].data,
        subTaskLatest:
          resArr[1].data.length > 0
            ? resArr[1].data[resArr[1].data.length - 1]
            : false,
        isLoading: false,
        isBgLoading: false,
      });
    }
  };

  handleCloseModal = () => {
    this.setState({
      renderModal: null,
    });
  };

  // FLOW SUBMIT
  // =============================
  // =============================
  handleSubmit = async (values) => {
    const { subTaskID } = this.state;
    this.setState({
      isBgLoading: true,
    });
    let params = {
      ...values,
      main_task_ref_id: this.props.router.params.id,
      appointment_time: moment(values.appointment_time).format("HH:mm"),
    };
    let res =
      subTaskID === "create"
        ? await portalService.POST_SUB_TASK_DETAIL(params)
        : await portalService.PUT_SUB_TASK_UPDATE(subTaskID, params);
    if (res && res.status === 200) {
      this.setState({
        renderModal: false,
      });
      toast.success("อัพเดตสำเร็จ");
      this.fetchData();
    } else {
      this.setState({
        isBgLoading: false,
      });
      toast.error("อัพเดตไม่สำเร็จ กรุณาเช็คเงื่อนไข");
    }
  };

  handleBack = () => {
    this.props.router.navigate(-1);
  };

  handleAddSubTask = (e) => {
    const { mainTaskDetail } = this.state;
    if (e === "create") {
      this.setState({
        subTaskID: e,
        renderModal: (
          <Forms.SubTaskForm
            mainTaskCode={mainTaskDetail?.main_task_code}
            // initialValues={initialValues}
            onCancel={this.handleCloseModal}
            onSubmit={this.handleSubmit}
          />
        ),
      });
    } else {
      this.setState({
        subTaskID: e._id,
        renderModal: (
          <Forms.SubTaskForm
            initialValues={e}
            onCancel={this.handleCloseModal}
            onSubmit={this.handleSubmit}
          />
        ),
      });
    }
  };

  render() {
    const {
      isLoading,
      isBgLoading,
      renderModal,
      subTaskData,
      subTaskLatest,
      mainTaskDetail,
    } = this.state;
    return (
      <SubTaskDetailContainerStyled>
        <Displays.BGLoading visible={isBgLoading} />
        {isLoading ? (
          <div className="loading_show">
            <Displays.Loading theme_standard_loading />
          </div>
        ) : (
          <>
            <div className="line" />
            <div className="title_wrap">
              <div className="title">Main Task</div>
              <div className="title_detail">
                {mainTaskDetail.main_task_code}
              </div>
            </div>
            <div className="sec_row_wrap">
              <div className="sec_left">
                <div className="sec_title">Product Owner</div>
                <div className="row_wrap">
                  <div className="row_title">Name </div>
                  <div className="row_value">
                    {mainTaskDetail.cus_first_name}{" "}
                    {mainTaskDetail.cus_last_name}
                  </div>
                </div>
                <div className="row_wrap">
                  <div className="row_title">Phone </div>
                  <div className="row_value">
                    {mainTaskDetail.cus_phone_number}
                  </div>
                </div>
              </div>
              <div className="sec-right">
                <div className="sec_title">Product Detail</div>
                <div className="row_wrap">
                  <div className="row_title">Name</div>
                  <div className="row_value">{mainTaskDetail.product_th}</div>
                </div>
                <div className="row_wrap">
                  <div className="row_title">Instrument Type</div>
                  <div className="row_value">
                    {mainTaskDetail.instrument_type_th}
                  </div>
                </div>
                <div className="row_wrap">
                  <div className="row_title">Brand</div>
                  <div className="row_value">
                    {mainTaskDetail.instrument_brand}
                  </div>
                </div>
                <div className="row_wrap">
                  <div className="row_title">Model</div>
                  <div className="row_value">
                    {mainTaskDetail.instrument_model || "-"}
                  </div>
                </div>
                <div className="row_wrap">
                  <div className="row_title">Series</div>
                  <div className="row_value">
                    {mainTaskDetail.instrument_series || "-"}
                  </div>
                </div>
                <div className="row_wrap">
                  <div className="row_title">Serial no</div>
                  <div className="row_value">
                    {mainTaskDetail.instrument_serial_no || "-"}
                  </div>
                </div>
              </div>
            </div>
            <div className="line" />
            <div className="subtask_wrap">
              <div className="left_subtask">Lastest Sub Task</div>
              {(!subTaskLatest ||
                (subTaskLatest && subTaskLatest.status === "2")) && (
                <div className="right_subtask">
                  <Buttons.BgIconPrefix
                    className="btn"
                    icon={<MdAdd size={18} />}
                    label={"New"}
                    onClick={() => this.handleAddSubTask("create")}
                  />
                </div>
              )}
            </div>
            {subTaskLatest && (
              <div className="sub_task_data">
                <Forms.SubTaskActionUpdateForm
                  initialValues={subTaskLatest}
                  mainTaskID={this.props.router.params.id}
                  onEdit={this.handleAddSubTask}
                />
              </div>
            )}
            <div className="table_layout">
              <Tables.Standard
                columns={columns()}
                data={subTaskData.slice(0, -1)}
              />
            </div>
            <div className="btn_wrap">
              <Buttons.BgStandard
                className="btn"
                theme_gray
                label={"Back"}
                onClick={this.handleBack}
              />
            </div>
          </>
        )}
        <Modals.BodyEmpty
          isShowModal={renderModal}
          onCloseModal={this.handleCloseModal}
        >
          {renderModal}
        </Modals.BodyEmpty>
      </SubTaskDetailContainerStyled>
    );
  }
}

const columns = () => [
  {
    Header: <div style={{ textAlign: "left" }}>Create Date</div>,
    accessor: "created_at",
    Cell: (props) =>
      momentTZ(props.value).tz("Asia/Bangkok").format("DD/MM/YYYY HH:mm"),
  },
  {
    Header: <div style={{ textAlign: "left" }}>Appointment date</div>,
    accessor: "appointment_date",
    Cell: (props) =>
      momentTZ(props.value).tz("Asia/Bangkok").format("DD/MM/YYYY"),
  },
  {
    Header: <div style={{ textAlign: "left" }}>Appointment time</div>,
    accessor: "appointment_time",
    Cell: (props) => props.value,
  },
  {
    Header: <div style={{ textAlign: "left" }}>Sub Task</div>,
    accessor: "sub_task_code",
    Cell: (props) => props.value || "-",
  },
  {
    Header: <div style={{ textAlign: "left" }}>Call confirmed</div>,
    accessor: "is_call_confirm",
    Cell: (props) => (props.value ? "Yes" : "-"),
  },
  {
    Header: <div style={{ textAlign: "left" }}>Service Completed</div>,
    accessor: "is_service_complete",
    Cell: (props) => (props.value ? "Yes" : "-"),
  },
  {
    Header: <div style={{ textAlign: "left" }}>Next call - Follow up</div>,
    accessor: "next_call_date",
    Cell: (props) =>
      !props.value
        ? "-"
        : momentTZ(props.value).tz("Asia/Bangkok").format("DD/MM/YYYY"),
  },
];

const mapStateToProps = (state) => ({
  authenRedux: state.authenRedux,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(SubTaskDetailContainer));
